var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291.87 385.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffbebc;}.cls-2{fill:#020288;}.cls-3{fill:none;stroke-width:10px;}.cls-3,.cls-4{stroke:#020288;stroke-miterlimit:10;}.cls-4{fill:#fff;stroke-width:10.73px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m255.58,282.83h-61.2c-3.35,0-6.07,2.72-6.07,6.07v61.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.15,31.82c0-6.67-2.08-21.33,9.06-19.8,9.07,1.24,6.93,13.14,6.93,19.54,0,8.96,0,17.92,0,26.87,0,3.44-.39,6.73-3.6,8.84-5.4,3.54-12.1-.51-12.39-6.69-.37-7.69-12.37-7.73-12,0,.78,16.32,19.51,26.22,32.71,15.39,8.21-6.74,7.28-16.6,7.28-26.07s.07-18.96,0-28.45c-.09-13.06-10.72-23.82-24.25-21.01-8.35,1.73-14.65,9-15.57,17.38-.51,4.6-.17,9.36-.17,13.99,0,7.72,12,7.73,12,0h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 163.74,
    y: 78.55,
    width: 61.8,
    height: 15.31,
    rx: 7.65,
    ry: 7.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.84,
    y: 112.56,
    width: 200.69,
    height: 15.31,
    rx: 7.65,
    ry: 7.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.84,
    y: 145.45,
    width: 200.69,
    height: 15.31,
    rx: 7.65,
    ry: 7.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.84,
    y: 212.91,
    width: 200.69,
    height: 15.31,
    rx: 7.65,
    ry: 7.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.84,
    y: 245.79,
    width: 200.69,
    height: 15.31,
    rx: 7.65,
    ry: 7.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.84,
    y: 178.9,
    width: 110.55,
    height: 15.31,
    rx: 7.65,
    ry: 7.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.84,
    y: 281.51,
    width: 62.93,
    height: 15.31,
    rx: 7.65,
    ry: 7.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m256.43,76.28h35.43v309.54H44.12v-34.02h144.57l67.75-67.75s.85-208.63,0-207.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m191.52,351.81H8.4c-1.88,0-3.4-1.52-3.4-3.4V42.27c0-1.88,1.52-3.4,3.4-3.4h242.08c1.88,0,3.4,1.52,3.4,3.4v243.21l-62.36,66.33Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.3134e71001b97380dfa33ee1360b9f95.svg";
export { ForwardRef as ReactComponent };